module.exports = __webpack_public_path__ + "img/logo_white.89b7bc28.svg";